import { Link, useLocation } from "react-router-dom";

import styled from "styled-components";
import logo from "../assets/logo.png";
import { useGlobaleContext } from "../context";

const Nav = () => {
  const { toggleSidebar, isSidebarOpen } = useGlobaleContext();
  const { pathname } = useLocation();

  return (
    <NavContainer>
      <div className="nav-header">
        <Link to="/" className="logo__link">
          <img
            src={logo}
            className="logo__image"
            alt="logo"
            width="48.0333px"
            height="48.0333px"
          />
        </Link>
        <button
          aria-label="menu"
          type="button"
          className="nav-toggle"
          onClick={() => {
            toggleSidebar();
          }}
        >
          <span className={isSidebarOpen ? "nav__icon open" : "nav__icon"}>
            &nbsp;
          </span>
        </button>
      </div>

      <ul className="nav-links">
        <li className="nav-link ">
          <Link to="/" aria-label="Home page" tabIndex="1">
            <svg
              stroke={pathname === "/" ? "#63b3ed" : "currentColor"}
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              strokeWidth="1"
              viewBox="2 0 24 24"
              width="33.3667px"
              heigh="50px"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"
              />
            </svg>
          </Link>
        </li>
        <li className="nav-link">
          <Link to="/about" aria-label="about page" tabIndex="2">
            <svg
              fill={pathname === "/about" ? "#63b3ed" : "currentColor"}
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 50 50"
              width="33.3667px"
              heigh="50px"
            >
              <path d="M 40.90625 3 C 39.800781 3 39 3.785156 39 4.90625 C 39 6.011719 39.796875 6.8125 40.90625 6.8125 C 42.015625 6.8125 42.78125 6.011719 42.78125 4.90625 C 42.78125 3.785156 42.011719 3 40.90625 3 Z M 20.96875 5 C 16.28125 5.085938 13.300781 7.105469 12 10.125 C 10.761719 13 10.988281 16.617188 11.875 20.28125 C 11.398438 20.839844 11.019531 21.589844 11.15625 22.71875 C 11.304688 23.949219 11.644531 24.824219 12.125 25.4375 C 12.390625 25.773438 12.738281 25.804688 13.0625 25.96875 C 13.238281 27.015625 13.53125 28.0625 13.96875 28.9375 C 14.21875 29.441406 14.503906 29.90625 14.78125 30.28125 C 14.90625 30.449219 15.085938 30.546875 15.21875 30.6875 C 15.226563 31.933594 15.234375 32.960938 15.125 34.28125 C 14.789063 35.078125 14.066406 35.707031 12.9375 36.3125 C 11.761719 36.941406 10.234375 37.5 8.6875 38.21875 C 7.140625 38.9375 5.539063 39.839844 4.28125 41.21875 C 3.023438 42.597656 2.148438 44.46875 2 46.9375 L 1.9375 48 L 40.0625 48 L 40 46.9375 C 39.851563 44.46875 38.972656 42.597656 37.71875 41.21875 C 36.464844 39.839844 34.886719 38.941406 33.34375 38.21875 C 31.800781 37.496094 30.296875 36.941406 29.125 36.3125 C 28.003906 35.707031 27.273438 35.082031 26.9375 34.28125 C 26.828125 32.964844 26.835938 31.933594 26.84375 30.6875 C 26.976563 30.542969 27.15625 30.449219 27.28125 30.28125 C 27.554688 29.902344 27.816406 29.4375 28.0625 28.9375 C 28.488281 28.0625 28.796875 27.011719 28.96875 25.96875 C 29.28125 25.804688 29.617188 25.765625 29.875 25.4375 C 30.355469 24.824219 30.695313 23.949219 30.84375 22.71875 C 30.976563 21.625 30.609375 20.902344 30.15625 20.34375 C 30.644531 18.757813 31.269531 16.195313 31.0625 13.5625 C 30.949219 12.125 30.582031 10.691406 29.71875 9.5 C 28.90625 8.378906 27.589844 7.558594 25.90625 7.25 C 24.914063 5.949219 23.242188 5 21 5 Z M 21 7 C 21.011719 7 21.019531 7 21.03125 7 C 22.929688 7.011719 24.1875 7.886719 24.625 8.65625 L 24.875 9.0625 L 25.34375 9.125 C 26.734375 9.320313 27.53125 9.878906 28.09375 10.65625 C 28.65625 11.433594 28.96875 12.519531 29.0625 13.71875 C 29.25 16.117188 28.558594 18.910156 28.125 20.21875 L 27.875 21 L 28.5625 21.40625 C 28.519531 21.378906 28.945313 21.667969 28.84375 22.5 C 28.726563 23.480469 28.492188 23.988281 28.3125 24.21875 C 28.132813 24.449219 28.039063 24.4375 28.03125 24.4375 L 27.1875 24.5 L 27.09375 25.3125 C 27 26.175781 26.652344 27.234375 26.25 28.0625 C 26.046875 28.476563 25.839844 28.839844 25.65625 29.09375 C 25.472656 29.347656 25.28125 29.488281 25.375 29.4375 L 24.84375 29.71875 L 24.84375 30.3125 C 24.84375 31.761719 24.785156 32.949219 24.9375 34.625 L 24.9375 34.75 L 25 34.875 C 25.558594 36.378906 26.796875 37.332031 28.15625 38.0625 C 29.515625 38.792969 31.0625 39.359375 32.5 40.03125 C 33.9375 40.703125 35.246094 41.488281 36.21875 42.5625 C 36.996094 43.417969 37.515625 44.5625 37.78125 46 L 4.21875 46 C 4.488281 44.5625 5 43.417969 5.78125 42.5625 C 6.761719 41.488281 8.085938 40.703125 9.53125 40.03125 C 10.976563 39.359375 12.511719 38.792969 13.875 38.0625 C 15.238281 37.332031 16.5 36.382813 17.0625 34.875 L 17.125 34.625 C 17.277344 32.949219 17.21875 31.761719 17.21875 30.3125 L 17.21875 29.71875 L 16.6875 29.4375 C 16.777344 29.484375 16.5625 29.347656 16.375 29.09375 C 16.1875 28.839844 15.957031 28.476563 15.75 28.0625 C 15.335938 27.234375 14.996094 26.167969 14.90625 25.3125 L 14.8125 24.5 L 13.96875 24.4375 C 13.960938 24.4375 13.867188 24.449219 13.6875 24.21875 C 13.507813 23.988281 13.273438 23.480469 13.15625 22.5 C 13.058594 21.667969 13.480469 21.378906 13.4375 21.40625 L 14.09375 21 L 13.90625 20.28125 C 12.96875 16.664063 12.832031 13.285156 13.84375 10.9375 C 14.851563 8.597656 16.855469 7.085938 21 7 Z M 38 9 L 38 11 L 40 11 L 40 21 L 38 21 L 38 23 L 44 23 L 44 21 L 42 21 L 42 9 Z" />
            </svg>
          </Link>
        </li>
        <li className="nav-link">
          <Link to="/projects" aria-label="projects page" tabIndex="3">
            <svg
              fill={pathname === "/projects" ? "#63b3ed" : "currentColor"}
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 50 50"
              width="33.3667px"
              heigh="50px"
            >
              <path d="M 49.601563 8.898438 C 49.5 8.601563 49.199219 8.300781 48.898438 8.300781 C 48.601563 8.199219 48.199219 8.300781 48 8.601563 L 42.699219 13.898438 C 42.398438 14.199219 41.800781 14.199219 41.5 13.898438 L 36.199219 8.601563 C 35.898438 8.300781 35.898438 7.699219 36.199219 7.398438 L 41.5 2 C 41.699219 1.800781 41.800781 1.398438 41.800781 1.101563 C 41.699219 0.800781 41.5 0.5 41.199219 0.398438 C 37.199219 -1 30.800781 1.898438 28.199219 4.5 C 25.601563 7.101563 25.300781 10.699219 27.398438 14.601563 L 27.199219 14.800781 L 25 12.5 C 23.101563 10.398438 20.5 9.199219 17.601563 9.101563 C 14.699219 9 12.101563 10.101563 10.101563 12.101563 L 3.101563 19.101563 C -0.898438 23.101563 -0.898438 29.601563 3.101563 33.601563 L 5 35.5 L 2 38.300781 C 1.199219 39.101563 0.300781 40.5 0 42.300781 C -0.101563 43.800781 0 45.898438 2 48 C 3.601563 49.601563 5.300781 50 6.699219 50 C 7 50 7.398438 50 7.699219 49.898438 C 9.5 49.601563 10.898438 48.699219 11.699219 47.898438 L 15.101563 44.398438 C 15.300781 44.398438 15.5 44.5 15.800781 44.5 C 17.398438 44.5 18.898438 43.699219 19.699219 42.398438 C 20.199219 42.601563 20.800781 42.699219 21.300781 42.699219 C 23.601563 42.699219 25.5 41.101563 25.898438 38.898438 C 26.199219 39 26.5 39 26.800781 39 C 29.101563 39 31 37.398438 31.398438 35.199219 C 31.699219 35.300781 32 35.300781 32.300781 35.300781 C 34.898438 35.300781 37 33.199219 37 30.601563 C 37 29.199219 36.300781 27.800781 35.199219 26.898438 L 33.199219 24.898438 L 35.398438 22.699219 C 39.300781 24.800781 42.800781 24.5 45.5 21.898438 C 48.101563 19.199219 51 12.800781 49.601563 8.898438 Z M 10.300781 46.5 C 9.800781 47 8.699219 47.699219 7.398438 47.898438 C 5.898438 48.101563 4.601563 47.601563 3.5 46.5 C 2.300781 45.300781 1.898438 44 2.101563 42.601563 C 2.300781 41.300781 3 40.300781 3.5 39.699219 L 6.398438 36.898438 L 12.199219 42.699219 C 12.5 43 12.800781 43.300781 13.199219 43.601563 Z M 34 28.398438 C 34.699219 28.898438 35.101563 29.699219 35.101563 30.5 C 35.101563 32 33.898438 33.199219 32.398438 33.199219 C 31.898438 33.199219 31.5 33.101563 31 32.800781 L 29.199219 31.699219 L 29.5 33.800781 C 29.5 33.898438 29.5 34 29.5 34.199219 C 29.5 35.699219 28.300781 36.898438 26.800781 36.898438 C 26.300781 36.898438 25.898438 36.800781 25.398438 36.5 L 23.601563 35.398438 L 23.898438 37.5 C 23.898438 37.601563 23.898438 37.699219 23.898438 37.898438 C 23.898438 39.398438 22.699219 40.601563 21.199219 40.601563 C 20.699219 40.601563 20.101563 40.398438 19.699219 40.101563 L 18.601563 39.398438 L 18.199219 40.601563 C 17.800781 41.699219 16.800781 42.398438 15.699219 42.398438 C 14.898438 42.398438 14.101563 42 13.601563 41.398438 L 4.398438 32.199219 C 1.199219 29 1.199219 23.699219 4.398438 20.5 L 11.398438 13.5 C 13 11.898438 15.199219 11 17.5 11.101563 C 19.800781 11.199219 21.898438 12.101563 23.5 13.898438 L 25.800781 16.300781 L 25.199219 16.898438 L 25 16.601563 C 24.601563 16.199219 24 16.199219 23.601563 16.601563 C 23.199219 17 23.199219 17.601563 23.601563 18 L 33.898438 28.300781 Z M 44 20.398438 C 41.300781 23.101563 38 22 35.699219 20.5 C 35.300781 20.300781 34.800781 20.300781 34.5 20.699219 L 31.800781 23.398438 L 26.601563 18.199219 L 29.300781 15.5 C 29.601563 15.199219 29.699219 14.699219 29.5 14.300781 C 28.101563 11.898438 27 8.601563 29.601563 6 C 31.5 4.101563 35.601563 2.101563 38.699219 2 L 34.800781 5.898438 C 33.699219 7 33.699219 8.800781 34.800781 10 L 40.101563 15.300781 C 41.199219 16.398438 43 16.398438 44.199219 15.300781 L 48.101563 11.398438 C 48 14.398438 45.898438 18.5 44 20.398438 Z" />
            </svg>
          </Link>
        </li>

        <li className="nav-link">
          <Link to="/contact" aria-label="contact page" tabIndex="4">
            <svg
              stroke={pathname === "/contact" ? "#63b3ed" : "currentColor"}
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              strokeWidth="1"
              viewBox="2 0 24 24"
              width="33.3667px"
              heigh="50px"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M3 19v-8.93a2 2 0 01.89-1.664l7-4.666a2 2 0 012.22 0l7 4.666A2 2 0 0121 10.07V19M3 19a2 2 0 002 2h14a2 2 0 002-2M3 19l6.75-4.5M21 19l-6.75-4.5M3 10l6.75 4.5M21 10l-6.75 4.5m0 0l-1.14.76a2 2 0 01-2.22 0l-1.14-.76"
              />
            </svg>
          </Link>
        </li>
        <li className="nav-link">
          <a
            target="_blank"
            rel="noopener noreferrer"
            aria-label="resume"
            href="https://drive.google.com/file/d/1Hk0gFnrosEhp8doWZws__uEw7BYZ_0e7/view"
            tabIndex="5"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 64 64"
              width="64px"
              height="64px"
              fill="currentColor"
            >
              <circle cx="49" cy="29.5" r="4" fill="#3e3ef4" />
              <path
                fill="#3e3ef4"
                d="M49,17.5A14.5,14.5,0,1,0,63.5,32,14.51669,14.51669,0,0,0,49,17.5Zm6,25A1.50008,1.50008,0,0,1,53.5,41a4.5,4.5,0,0,0-9,0,1.5,1.5,0,0,1-3,0,7.48738,7.48738,0,0,1,3.10162-6.06189,7,7,0,1,1,8.79676,0A7.48738,7.48738,0,0,1,56.5,41,1.50007,1.50007,0,0,1,55,42.5Z"
              />
              <path d="M.94049,49.06158,14.9386,63.05969A1.53388,1.53388,0,0,0,16,63.5H43A4.50491,4.50491,0,0,0,47.5,59V50.73926a1.5,1.5,0,0,0-3,0V59A1.50164,1.50164,0,0,1,43,60.5H17.5V51A4.50491,4.50491,0,0,0,13,46.5H3.5V5A1.50164,1.50164,0,0,1,5,3.5H43A1.50164,1.50164,0,0,1,44.5,5v8.26074a1.5,1.5,0,0,0,3,0V5A4.50491,4.50491,0,0,0,43,.5H5A4.50491,4.50491,0,0,0,.5,5V48A1.508,1.508,0,0,0,.94049,49.06158ZM14.5,51v7.37891L5.62109,49.5H13A1.50164,1.50164,0,0,1,14.5,51Z" />
              <path d="M24,6.5H8a1.5,1.5,0,0,0,0,3H24a1.5,1.5,0,0,0,0-3Z" />
              <path d="M19.5,14A1.50007,1.50007,0,0,0,18,12.5H8a1.5,1.5,0,0,0,0,3H18A1.50007,1.50007,0,0,0,19.5,14Z" />
              <path d="M12,18.5A5.5,5.5,0,1,0,17.5,24,5.50654,5.50654,0,0,0,12,18.5Zm0,8A2.5,2.5,0,1,1,14.5,24,2.50263,2.50263,0,0,1,12,26.5Z" />
              <path d="M31,19.5H21a1.5,1.5,0,0,0,0,3H31a1.5,1.5,0,0,0,0-3Z" />
              <path d="M21,28.5h6a1.5,1.5,0,0,0,0-3H21a1.5,1.5,0,0,0,0,3Z" />
              <path d="M12,32.5A5.5,5.5,0,1,0,17.5,38,5.50654,5.50654,0,0,0,12,32.5Zm0,8A2.5,2.5,0,1,1,14.5,38,2.50263,2.50263,0,0,1,12,40.5Z" />
              <path d="M32.5,35A1.50007,1.50007,0,0,0,31,33.5H21a1.5,1.5,0,0,0,0,3H31A1.50007,1.50007,0,0,0,32.5,35Z" />
              <path d="M21,39.5a1.5,1.5,0,0,0,0,3h6a1.5,1.5,0,0,0,0-3Z" />
              <path d="M39.5,49A1.50007,1.50007,0,0,0,38,47.5H21a1.5,1.5,0,0,0,0,3H38A1.50007,1.50007,0,0,0,39.5,49Z" />
              <path d="M21,53.5a1.5,1.5,0,0,0,0,3H34a1.5,1.5,0,0,0,0-3Z" />
            </svg>
          </a>
          {/* <Link to="/contact">
            <svg
              stroke={pathname === "/contact" ? "#63b3ed" : "currentColor"}
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              strokeWidth="1"
              viewBox="2 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M3 19v-8.93a2 2 0 01.89-1.664l7-4.666a2 2 0 012.22 0l7 4.666A2 2 0 0121 10.07V19M3 19a2 2 0 002 2h14a2 2 0 002-2M3 19l6.75-4.5M21 19l-6.75-4.5M3 10l6.75 4.5M21 10l-6.75 4.5m0 0l-1.14.76a2 2 0 01-2.22 0l-1.14-.76"
              />
            </svg>
          </Link> */}
        </li>
      </ul>
    </NavContainer>
  );
};

const NavContainer = styled.nav`
  height: 100%;

  grid-column: navbar-start/navbar-end;
  grid-row: 1/-1;

  display: flex;
  flex-direction: column;
  justify-content: flex-start;

  .nav-header {
    display: flex;
    -moz-box-align: center;
    align-items: center;
    -moz-box-pack: justify;
    justify-content: space-between;
    position: relative;
  }

  .logo__link {
    width: 4.32rem;
    display: block;
    margin-top: 5px;
  }

  .logo__image {
    width: inherit;
  }
  .nav-toggle {
    cursor: pointer;
    width: 5rem;
    height: 5rem;
    z-index: 999;
    position: fixed;
    inset: 0 0 auto auto;
    border: none;
    background-color: white;
  }

  @media (max-width: 900px) {
    .logo__link {
      width: 6.32rem;
    }
    .nav-toggle {
      width: 7rem;
      height: 7rem;
    }
  }

  .nav__icon {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 7rem;
    height: 7rem;
    transform: translate(-50%, -50%);
    transition: all 0.2s ease-in-out;
  }
  .nav__icon,
  .nav__icon::before,
  .nav__icon::after {
    width: 28px;
    height: 3px;
    background: var(--colors-accent-700);
    transition: all 0.8s cubic-bezier(1, 0.47, 0, 1.27);
  }

  .nav__icon::before,
  .nav__icon::after {
    content: "";
    position: absolute;
    left: 0;
  }

  .nav__icon::before {
    top: -11px;
  }
  .nav__icon::after {
    top: 10px;
    width: 20px;
  }

  .nav__icon.open {
    transform: translate(-50%, -50%) rotate(-720deg);
    background-color: transparent;
  }
  .nav__icon.open::before {
    transform: rotate(-45deg);
    top: 0;
  }
  .nav__icon.open::after {
    transform: rotate(45deg);
    top: 0;
    left: 0;
    width: 28px !important;
  }

  .nav-links {
    list-style-type: none;
    padding: 0;
    margin: 0;
    margin-top: 25vh;
  }
  .nav-link {
    width: 3rem;
    border-radius: var(--border-radius);
    margin: auto;
    margin-bottom: 3rem;
  }

  .nav-link a {
    display: block;
    position: relative;
    width: 100%;
    height: 100%;
  }
  .nav-link a svg {
    width: 100%;
    transition: var(--transition);
  }
  .nav-link a::after {
    content: "";
    font-size: 9px;
    letter-spacing: 2px;
    text-align: center;
    text-transform: uppercase;
    color: var(--colors-accent-300);

    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    display: block;
    width: 100%;

    opacity: 0;
    transition: var(--transition);
  }

  .nav-link a:nth-child(1)::after {
    content: "Home";
  }
  .nav-link:nth-child(2) a::after {
    content: "About";
  }
  .nav-link:nth-child(3) a::after {
    content: "projects";
    transform: translate(-80%, -50%);
    padding-left: 1rem;
  }
  .nav-link:nth-child(4) a::after {
    content: "contact";
    transform: translate(-80%, -50%);
    padding-left: 1rem;
  }
  .nav-link:nth-child(5) {
    a::after {
      content: "Resume";
      transform: translate(-80%, -50%);
      padding-left: 1rem;
    }
    a {
      cursor: alias;
    }
  }

  .nav-link:hover {
    a svg {
      transform: translateX(-200%);
    }
    a::after {
      opacity: 1;
    }
  }

  @media (min-width: 992px) {
    .nav-header .nav-toggle {
      display: none;
    }
  }

  @media (max-width: 992px) {
    grid-row: navbar-start/navbar-end;
    grid-column: 1/-1;
    .nav-links {
      display: none;
    }
    .nav-link.logo {
      margin: 0;
    }
  }
`;
export default Nav;
